import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from '../custom-validator';
import { Constants } from '../constants';
import { MessageService } from 'primeng/api';
import { SharedUserService } from '../services/shared-user.service';
import { takeUntil, finalize } from 'rxjs/operators';
import { BaseComponent } from '../components/base.component';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { resetFakeAsyncZone } from '@angular/core/testing';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { ConfigResponseModel } from '../models/response/client-config-response';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PasswordExpiry } from '../models/response/user-response-model';
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.sass'],
    standalone: false
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input("config") config: any = {
		type: 1,
		length: 6,
		cssClass: "custom",
		back: {
			stroke: "#2F9688",
			solid: "#f2efd2",
		},
		font: {
			color: "#000000",
			size: "35px",
      family: "Arial, Helvetica, sans-serif",
		},
	};
	captchaCode: any = null;
	resultCode: any = null;
	checkCaptchaValue: boolean = false;

  title = 'Reset Password';
  private unsubscriber = new Subject<boolean>();
  formFields = {
    email: 'email',
    captcha: 'captcha'
  };

  configResponseModel: ConfigResponseModel;
  imageUrl: SafeResourceUrl;
  imageData: string;
  imagealt: string;
  imageTitle: string;
  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private userService: SharedUserService,
    messageService: MessageService,
    private webStorageService: WebStorageService,
    private sanitizer: DomSanitizer) {
    super(messageService);
    this.buildForm();
  }

  ngOnInit() {
    this.configResponseModel = this.webStorageService.getClientConfig();
    this.imageData = 'data:image/png;base64, ' + this.configResponseModel.companyLogo;
    this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.imageData);
    this.imagealt = this.configResponseModel.companyName;
    this.imageTitle = this.configResponseModel.companyName;
    this.generateCaptcha();
  }


  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }

    if(!this.checkCaptcha()) {
      this.reloadCaptcha();
      setTimeout(() => {
        this.checkCaptchaValue = false;
      }, 2000);
      return;
    }    

    this.loading = true;
    const email = this.form.get(this.formFields.email).value;
    const forgotPwd = new PasswordExpiry();
    forgotPwd.appUserEmail = email;
    await this.userService.forgotPassword(forgotPwd)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result) => {
        
        if (result.isSuccess) {
          this.loading = false;
          this.showSuccessMessage("If this email is associated with an account, a reset link has been sent");
          this.router.navigate(['/login']);
        }
        else {
          this.showWarningMessage(result.message);
        }
        this.reloadCaptcha();

      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private buildForm() {
    const formGroup = this.formBuilder.group({});

    // tslint:disable-next-line: max-line-length
    formGroup.addControl(this.formFields.email, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace, CustomValidator.email], updateOn: Constants.formControlUpdateStrategy.blur }));
    formGroup.addControl(this.formFields.captcha, this.formBuilder.control('', { validators: [Validators.required, CustomValidator.whitespace], updateOn: Constants.formControlUpdateStrategy.blur }));
    this.form = formGroup;
  }

  generateCaptcha() {
		
      // Generate English letters (A-Z) and numbers (0-9)
      const englishChars = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
      let char = '';

      for (let i = 0; i < this.config.length; i++) {
          char += englishChars.charAt(Math.floor(Math.random() * englishChars.length));
      }
      this.captchaCode = this.resultCode = char.toUpperCase();
      
		setTimeout(() => {
			let captchaCanvas: any = document.getElementById("captchaId");
			var ctx = captchaCanvas.getContext("2d");
			ctx.fillStyle = this.config.back.solid;
			ctx.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height);

			ctx.beginPath();

			captchaCanvas.style.letterSpacing = 15 + "px";
      captchaCanvas.style.width = 200 + "px";
			ctx.font = this.config.font.size + " " + this.config.font.family;
			ctx.fillStyle = this.config.font.color;
			ctx.textBaseline = "middle";
			ctx.fillText(this.captchaCode, 40, 50);
			if (this.config.back.stroke) {
				ctx.strokeStyle = this.config.back.stroke;
				for (var i = 0; i < 150; i++) {
					ctx.moveTo(Math.random() * 300, Math.random() * 300);
					ctx.lineTo(Math.random() * 300, Math.random() * 300);
				}
				ctx.stroke();
			}
		}, 100);
	}

	reloadCaptcha(): void {
		this.generateCaptcha();
	}

  checkCaptcha() {
    if (this.form.get(this.formFields.captcha).value === this.resultCode) {
			this.checkCaptchaValue = false;
			return true;
		} else {
			this.checkCaptchaValue = true;
      return false
		}
	}

}
